export default __webpack_public_path__ + "loginrecuperar.jpg";